export class ClaimModel {
  userId: string;
  email: string;
  //sub: string;
  preferred_username: string;
  name: string;
  role: string[];
  accountStatus: string;

  setAuth(claim: ClaimModel) {
    this.userId = claim.userId;
    this.email = claim.email;
    //this.sub = claim.sub;
    this.preferred_username = claim.preferred_username;
    this.name = claim.name;
    this.role = claim.role;
    this.accountStatus = claim.accountStatus;
  }
}
